var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.onTabClick },
          model: {
            value: _vm.auditType,
            callback: function($$v) {
              _vm.auditType = $$v
            },
            expression: "auditType"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "待审批", name: "1" } },
            [
              _c(
                "div",
                { staticClass: "search-term" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.auditingTable }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择油站" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value: _vm.auditingTable.searchInfo.stationId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditingTable.searchInfo,
                                    "stationId",
                                    $$v
                                  )
                                },
                                expression: "auditingTable.searchInfo.stationId"
                              }
                            },
                            _vm._l(_vm.stationOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "搜索条件", clearable: "" },
                            model: {
                              value: _vm.auditingTable.searchInfo.mobile,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.auditingTable.searchInfo,
                                  "mobile",
                                  $$v
                                )
                              },
                              expression: "auditingTable.searchInfo.mobile"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "营运车平台" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value: _vm.auditingTable.searchInfo.groupId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditingTable.searchInfo,
                                    "groupId",
                                    $$v
                                  )
                                },
                                expression: "auditingTable.searchInfo.groupId"
                              }
                            },
                            _vm._l(_vm.carGroupOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: { label: item.groupName, value: item.ID }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAuditingSubmit }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onAuditingReset } },
                            [_vm._v("重置")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.auditingTable.tableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "用户ID", prop: "uid" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手机号码", prop: "mobile" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "车牌号码", prop: "carNumber" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "专车平台", prop: "groupName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "申请油站", prop: "stationId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getStationName")(scope.row.stationId)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "申请时间",
                      prop: "CreatedAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.CreatedAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onAudit(scope.row)
                                  }
                                }
                              },
                              [_vm._v("审批")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.auditingTable.searchInfo.page,
                  "page-size": _vm.auditingTable.searchInfo.pageSize,
                  "page-sizes": [10, 30, 50, 100],
                  total: _vm.auditingTable.total,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handleAuditingCurrentChange,
                  "size-change": _vm.handleAuditingSizeChange
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "审批通过", name: "2" } },
            [
              _c(
                "div",
                { staticClass: "search-term" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.auditedTable }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择油站" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value: _vm.auditedTable.searchInfo.stationId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditedTable.searchInfo,
                                    "stationId",
                                    $$v
                                  )
                                },
                                expression: "auditedTable.searchInfo.stationId"
                              }
                            },
                            _vm._l(_vm.stationOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "搜索条件", clearable: "" },
                            model: {
                              value: _vm.auditedTable.searchInfo.mobile,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.auditedTable.searchInfo,
                                  "mobile",
                                  $$v
                                )
                              },
                              expression: "auditedTable.searchInfo.mobile"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "营运车平台" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value: _vm.auditedTable.searchInfo.groupId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditedTable.searchInfo,
                                    "groupId",
                                    $$v
                                  )
                                },
                                expression: "auditedTable.searchInfo.groupId"
                              }
                            },
                            _vm._l(_vm.carGroupOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: { label: item.groupName, value: item.ID }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "审核时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAuditedSubmit }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onAuditedReset } },
                            [_vm._v("重置")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.auditedTable.tableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "用户ID", prop: "uid" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手机号码", prop: "mobile" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "车牌号码", prop: "carNumber" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "专车平台", prop: "groupName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "申请油站", prop: "stationId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getStationName")(scope.row.stationId)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "申请时间",
                      prop: "CreatedAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.CreatedAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审核人", prop: "auditUserName" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "审核时间",
                      prop: "auditAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.auditAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审核说明", prop: "auditRemark" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审批结果", prop: "auditStatus" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.auditStatus == 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "success", effect: "plain" }
                                  },
                                  [_vm._v("审核通过")]
                                )
                              : _vm._e(),
                            scope.row.auditStatus == 3
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "warning", effect: "plain" }
                                  },
                                  [_vm._v("审核不通过")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onView(scope.row)
                                  }
                                }
                              },
                              [_vm._v("查看")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.auditedTable.searchInfo.page,
                  "page-size": _vm.auditedTable.searchInfo.pageSize,
                  "page-sizes": [10, 30, 50, 100],
                  total: _vm.auditedTable.total,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handleAuditedCurrentChange,
                  "size-change": _vm.handleAuditedSizeChange
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "审批不通过", name: "3" } },
            [
              _c(
                "div",
                { staticClass: "search-term" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.auditedUnpassTable }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择油站" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value:
                                  _vm.auditedUnpassTable.searchInfo.stationId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditedUnpassTable.searchInfo,
                                    "stationId",
                                    $$v
                                  )
                                },
                                expression:
                                  "auditedUnpassTable.searchInfo.stationId"
                              }
                            },
                            _vm._l(_vm.stationOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "搜索条件", clearable: "" },
                            model: {
                              value: _vm.auditedUnpassTable.searchInfo.mobile,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.auditedUnpassTable.searchInfo,
                                  "mobile",
                                  $$v
                                )
                              },
                              expression: "auditedUnpassTable.searchInfo.mobile"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "营运车平台" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value:
                                  _vm.auditedUnpassTable.searchInfo.groupId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditedUnpassTable.searchInfo,
                                    "groupId",
                                    $$v
                                  )
                                },
                                expression:
                                  "auditedUnpassTable.searchInfo.groupId"
                              }
                            },
                            _vm._l(_vm.carGroupOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: { label: item.groupName, value: item.ID }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "审核时间" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.unpassDateRangeValueArr,
                              callback: function($$v) {
                                _vm.unpassDateRangeValueArr = $$v
                              },
                              expression: "unpassDateRangeValueArr"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAuditedUnpassSubmit }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onAuditedUnpassReset } },
                            [_vm._v("重置")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.auditedUnpassTable.tableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "用户ID", prop: "uid" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手机号码", prop: "mobile" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "车牌号码", prop: "carNumber" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "专车平台", prop: "groupName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "申请油站", prop: "stationId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getStationName")(scope.row.stationId)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "申请时间",
                      prop: "CreatedAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.CreatedAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审核人", prop: "auditUserName" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "审核时间",
                      prop: "auditAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.auditAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审核说明", prop: "auditRemark" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审批结果", prop: "auditStatus" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.auditStatus == 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "success", effect: "plain" }
                                  },
                                  [_vm._v("审核通过")]
                                )
                              : _vm._e(),
                            scope.row.auditStatus == 3
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "warning", effect: "plain" }
                                  },
                                  [_vm._v("审核不通过")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onView(scope.row)
                                  }
                                }
                              },
                              [_vm._v("查看")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.auditedUnpassTable.searchInfo.page,
                  "page-size": _vm.auditedUnpassTable.searchInfo.pageSize,
                  "page-sizes": [10, 30, 50, 100],
                  total: _vm.auditedUnpassTable.total,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handleAuditedUnpassCurrentChange,
                  "size-change": _vm.handleAuditedUnpassSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.dialogVisible,
            title: _vm.dialogTitle,
            width: "70%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "手机号:", prop: "mobile" } },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "true" },
                                    model: {
                                      value: _vm.formData.mobile,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "mobile", $$v)
                                      },
                                      expression: "formData.mobile"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "车牌号:", prop: "carNumber" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "true" },
                                    model: {
                                      value: _vm.formData.carNumber,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "carNumber", $$v)
                                      },
                                      expression: "formData.carNumber"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "专快车平台:",
                                    prop: "groupName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "true" },
                                    model: {
                                      value: _vm.formData.groupName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "groupName", $$v)
                                      },
                                      expression: "formData.groupName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "申请油品:",
                                    prop: "oilCodeName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "true" },
                                    model: {
                                      value: _vm.formData.oilCodeName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "oilCodeName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.oilCodeName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "申请油站:",
                                    prop: "stationName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "true" },
                                    model: {
                                      value: _vm.formData.stationName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "stationName",
                                          $$v
                                        )
                                      },
                                      expression: "formData.stationName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审批意见:",
                                    prop: "auditRemark"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      clearable: "",
                                      placeholder: "请输入"
                                    },
                                    model: {
                                      value: _vm.formData.auditRemark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "auditRemark",
                                          $$v
                                        )
                                      },
                                      expression: "formData.auditRemark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "审批结果:",
                                    prop: "auditStatus"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择"
                                      },
                                      model: {
                                        value: _vm.formData.auditStatus,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "formData.auditStatus"
                                      }
                                    },
                                    [
                                      _vm.type == "view"
                                        ? _c("el-option", {
                                            key: 1,
                                            attrs: { label: "待审核", value: 1 }
                                          })
                                        : _vm._e(),
                                      _c("el-option", {
                                        key: 2,
                                        attrs: { label: "通过", value: 2 }
                                      }),
                                      _c("el-option", {
                                        key: 3,
                                        attrs: { label: "不通过", value: 3 }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 2 } }, [_vm._v("   ")]),
                  _c("el-col", { attrs: { span: 10 } }, [
                    _c("img", {
                      staticStyle: { width: "350px" },
                      attrs: { src: _vm.formData.imgUrl, alt: "" }
                    })
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _vm.type !== "view"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.enterDialog }
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }